import { render } from "./Dialog-menu.vue?vue&type=template&id=febf9f5a&scoped=true"
import script from "./Dialog-menu.vue?vue&type=script&lang=js"
export * from "./Dialog-menu.vue?vue&type=script&lang=js"

import "./Dialog-menu.vue?vue&type=style&index=0&id=febf9f5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-febf9f5a"]])

export default __exports__